import { Injectable } from '@angular/core';
import { InConfiguration } from '../core/models/config.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public configData: InConfiguration;

  constructor() {
    this.setConfigData();
  }

  setConfigData() {
    this.configData = {
      layout: {
        rtl: false,
        variant: 'dark',
        theme_color: 'black',
        logo_bg_color: 'black',
        sidebar: {
          collapsed: false,
          backgroundColor: 'dark'
        }
      }
    };
  }
}
